var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dropzone from 'react-dropzone';
import { useUploadFiles } from '../Hooks';
import { useUploadConfiguration } from '../UploadConfigurationProvider';
export const UploadDropZone = (props) => {
    const { children, onUploadStart, onBeforeUpload } = props, rest = __rest(props, ["children", "onUploadStart", "onBeforeUpload"]);
    const { supportedFileTypes: { acceptedTypesAsString }, } = useUploadConfiguration();
    const uploadFiles = useUploadFiles();
    return (_jsx(Dropzone, Object.assign({ onDrop: (files) => uploadFiles({ files, onUploadStart, onBeforeUpload }) }, rest, { children: ({ getRootProps, getInputProps }) => (_jsxs("div", Object.assign({}, getRootProps(), { children: [_jsx("input", Object.assign({}, getInputProps(), { accept: acceptedTypesAsString })), children] }))) })));
};
//# sourceMappingURL=UploadDropZone.js.map